import React from 'react';
import Header     from '../components/Header';
import Home       from '../components/Home';
import Projects   from '../components/Projects';
import Process    from '../components/Process';
import Experience from '../components/Experience';
import Skills     from '../components/Skills';
import Writing    from '../components/Writing';
import About      from '../components/About';
import Contact    from '../components/Contact';
import Footer     from '../components/Footer';
import ScrollUp   from '../components/ScrollUp';

const LandingPage = ({ darkTheme, toggleTheme }) => {
    return (
        <>
            <Header darkTheme={darkTheme} toggleTheme={toggleTheme} />

            <main className="main">
                {/* WHO — First impression, identity, value prop */}
                <Home />

                {/* WHAT — All projects, impact metrics, filterable by domain */}
                <Projects />

                {/* HOW — 4-step process pipeline */}
                <Process />

                {/* WHERE — Career timeline and education */}
                <Experience />

                {/* WHICH — Domain expertise with proof */}
                <Skills />

                {/* WRITING — Published articles & research blog */}
                <Writing />

                {/* WHY/HOW — Story, mission, approach */}
                <About />

                {/* Next step */}
                <Contact />
            </main>

            <Footer />
            <ScrollUp />
        </>
    );
};

export default LandingPage;
